import axios from "@/libs/api.request";

/*联动信息*/
export const getAllActionPlan= ({type}) => {
  const params = {
    type
  }
  return axios.request({
    url:'system-service/api-v1.0/PrePlan/getPrePlanList',
    params,
    method: 'get'
  })
}
export const getAllActionPlanForPage= (params) => {
  return axios.request({
    url:'system-service/api_v2.2.5/prePlan/query/queryAll.json',
    data:params,
    method: 'post'
  })
}

export const getActionPlanById = ({id})=>{
  const params = {
    id
  }
  return axios.request({
    url: 'system-service/api-v1.0/PrePlan/getPrePlanById',
    params,
    method: 'get'
  })
}

export const addActionPlan = (form,broadLog) => {
  const data = {...form}
  return axios.request({
    url:'system-service/api-v1.0/PrePlan/addPrePlan',
    data,
    method:'post',
    headers:{
      'Menu_id':broadLog.menu_id,
      'Sysuser_id':broadLog.sysuser_id,
      'Journal_title':encodeURIComponent(broadLog.journal_title)
    }
  })
}

export const updateActionPlan = (form,broadLog)=>{
  const data = {...form}

  return axios.request({
     url: 'system-service/api-v1.0/PrePlan/updatePrePlan',
    data,
    method: 'post',
    headers:{
      'Menu_id':broadLog.menu_id,
      'Sysuser_id':broadLog.sysuser_id,
      'Journal_title':encodeURIComponent(broadLog.journal_title)
    }
  })
}

export const deleteActionPlan = ({id,devName},broadLog) => {
  const data = {id,devName}
  return axios.request({
     url: 'system-service/api-v1.0/PrePlan/deletePrePlan',
    data,
    method: 'post',
    headers:{
      'Menu_id':broadLog.menu_id,
      'Sysuser_id':broadLog.sysuser_id,
      'Journal_title':encodeURIComponent(broadLog.journal_title)
    }
  })
}

/*联动详细信息*/
export const getDetailActionPlan = ({type}) => {
  const params = {
    type
  }
  return axios.request({
    url: 'system-service/api-v1.0/PrePlan/detail/getPrePlanDetailList',
    params,
    method: 'get'
  })
}

export const queryPrePlanByParams = ({type,cameraId,isActive,ext,portId})=>{
  const data = {
    alarmType: type,
    employeeId:cameraId,
    isActive: isActive,
    ext: ext,
    portId: portId
  }
  return axios.request({
    url: 'system-service/api-v1.0/PrePlan/queryPrePlan',
    data,
    method: 'post'
  })
}

export const getDetailPlanDetails = ({planId}) => {
  const params = {planId}
  return axios.request({
    url: 'system-service/api-v1.0/PrePlan/detail/getPrePlanDetailsByPlanId',
    params,
    method: 'get'
  })
}

export const doExecute = (id,action)=>{
  const data = {id, action}
  return axios.request({
    url:'api/app/alarmplan/plan/execute.json',
    data,
    method:'post'
  })
}

export const updateDetailActionPlan = (form,broadLog)=> {
  const data = {...form}

  return axios.request({
     url: 'system-service/api-v1.0/PrePlan/detail/updatePrePlanDetail',
    data,
    method: 'post',
    headers:{
      'Menu_id':broadLog.menu_id,
      'Sysuser_id':broadLog.sysuser_id,
      'Journal_title':encodeURIComponent(broadLog.journal_title)
    }
  })
}

export const addDetailActionPlan = (form,broadLog) => {
  const data = {...form}

  return axios.request({
     url: 'system-service/api-v1.0/PrePlan/detail/addPrePlanDetail',
    data,
    method: 'post',
    headers:{
      'Menu_id':broadLog.menu_id,
      'Sysuser_id':broadLog.sysuser_id,
      'Journal_title':encodeURIComponent(broadLog.journal_title)
    }
  })
}

export const deleteDetailActionPlan = ({Id,ppId},broadLog)=>{
  const data = {
    Id,
    ppId
  }

  return axios.request({
    url: 'system-service/api-v1.0/PrePlan/detail/deletePrePlanDetail',
    data,
    method: 'post',
    headers:{
      'Menu_id':broadLog.menu_id,
      'Sysuser_id':broadLog.sysuser_id,
      'Journal_title':encodeURIComponent(broadLog.journal_title)
    }
  })
}


export const queryVideo = ({exten,type,isActive,cameraAlarm}) => {
  const params = {
    exten,type,isActive,cameraAlarm
  }
  return axios.request({
    url: 'system-service/api-v1.0/PrePlan/getVideoByExten',
    params,
    method: 'get'
  })
}

export const queryPrePlan = ({exten,type}) => {
  const params = {
    exten,type
  }
  return axios.request({
    url: 'system-service/api-v1.0/PrePlan/getPrePlanByExten',
    params,
    method: 'get'
  })
}

export const queryAlarmDevices = () =>{
  return axios.request({
    url:'system-service/api-v1.0/PrePlan/getAlarmDevices',
    method: 'get'
  })
}

export const addPrePlanStatusLog = (status,planId)=>{
  return axios.request({
    url: 'system-service/api-v1.0/PrePlan/addPrePlanStatusLog',
    data:{status:status,planId:planId},
    method: 'post'
  })
}
export const queryVideoForTrigger = ({exten,type,cameraAlarm,portId}) => {
  const params = {
    exten,type,cameraAlarm,portId
  }
  return axios.request({
    url: 'system-service/api-v1.0/PrePlan/getVideoForTrigger',
    params,
    method: 'get'
  })
}

export const queryOutputAlarmDevices = () =>{
  return axios.request({
    url:'system-service/api-v1.0/PrePlan/getAlarmDevicesAndOutput',
    method: 'get'
  })
}
export const getOutputForTrigger = ({planId}) =>{
  const params = {
    planId
  }
  return axios.request({
    url:'system-service/api-v1.0/PrePlan/getOutputForTrigger',
    params,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/actionPlan.js